export function normalizeSubjectList(
  raw: string | string[] | undefined | null
): string[] {
  const parts = Array.isArray(raw) ? raw : raw ? [raw] : [];
  const seen = new Set<string>();
  const result: string[] = [];

  for (const part of parts) {
    for (const token of String(part).split(/[,\s]+/)) {
      const value = token.trim();
      if (!value) continue;
      const key = value.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      result.push(value);
    }
  }

  return result;
}

export function joinSubjectChips(chips: string[]): string {
  return chips.join(", ");
}
